// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NOUVF","title":"styles_title__19jl3"};